var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgCompany = function SvgCompany(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 95,
    viewBox: "0 0 99 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4326 34.2612H12.3013V93.5803H67.4326V34.2612Z",
    fill: "#D3D9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.614014 16.1238C0.614014 15.7334 0.930451 15.417 1.3208 15.417H78.3737C78.764 15.417 79.0804 15.7334 79.0804 16.1238V93.4628C79.0804 93.8532 78.764 94.1696 78.3737 94.1696H1.3208C0.930451 94.1696 0.614014 93.8532 0.614014 93.4628V16.1238ZM2.02758 16.8306V92.7561H77.6669V16.8306H2.02758Z",
    fill: "#697684"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6223 0.000731554C39.7916 -0.0673643 39.9808 -0.0672988 40.1501 0.000914332L78.638 15.5074C79 15.6533 79.1753 16.065 79.0294 16.4271C78.8835 16.7892 78.4718 16.9644 78.1097 16.8185L39.8857 1.41837L1.58466 16.8187C1.22249 16.9644 0.810848 16.7888 0.665226 16.4266C0.519604 16.0645 0.695147 15.6528 1.05731 15.5072L39.6223 0.000731554Z",
    fill: "#697684"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1787 0.65649C39.1787 0.266144 39.4951 -0.050293 39.8855 -0.050293H59.1102C59.2006 -0.050293 59.2902 -0.0329406 59.3741 0.000822823L97.9005 15.5073C98.2626 15.6531 98.438 16.0648 98.2923 16.4269C98.1465 16.789 97.7348 16.9644 97.3727 16.8186L58.9733 1.36327H39.8855C39.4951 1.36327 39.1787 1.04683 39.1787 0.65649Z",
    fill: "#697684"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3667 93.4998C98.3667 93.8901 98.0503 94.2065 97.6599 94.2065H78.3967C78.0064 94.2065 77.6899 93.8901 77.6899 93.4998L77.6899 16.1607C77.6899 15.7703 78.0064 15.4539 78.3967 15.4539H97.6599C98.0503 15.4539 98.3667 15.7703 98.3667 16.1607L98.3667 93.4998ZM96.9531 92.793L96.9531 16.8675H79.1035L79.1035 92.793H96.9531Z",
    fill: "#697684"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3411 76.4871C43.3411 76.0967 43.6575 75.7803 44.0478 75.7803H61.0765C61.4669 75.7803 61.7833 76.0967 61.7833 76.4871V93.579C61.7833 93.9693 61.4669 94.2858 61.0765 94.2858H44.0478C43.6575 94.2858 43.3411 93.9693 43.3411 93.579V76.4871ZM44.7546 77.1938V92.8722H60.3697V77.1938H44.7546Z",
    fill: "#697684"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3684 75.7803H67.432V77.1938H61.782V92.8335H67.432V94.2471H60.3684V75.7803Z",
    fill: "#697684"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5623 75.7803C52.9526 75.7803 53.269 76.0967 53.269 76.4871V82.4422C53.269 82.8325 52.9526 83.149 52.5623 83.149C52.1719 83.149 51.8555 82.8325 51.8555 82.4422V76.4871C51.8555 76.0967 52.1719 75.7803 52.5623 75.7803Z",
    fill: "#697684"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3411 59.3938C43.3411 59.0034 43.6575 58.687 44.0478 58.687H61.0765C61.4669 58.687 61.7833 59.0034 61.7833 59.3938V76.4857C61.7833 76.8761 61.4669 77.1925 61.0765 77.1925H44.0478C43.6575 77.1925 43.3411 76.8761 43.3411 76.4857V59.3938ZM44.7546 60.1006V75.7789H60.3697V60.1006H44.7546Z",
    fill: "#697684"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3684 58.687H67.432V60.1006H61.782V75.7789H67.432V77.1925H60.3684V58.687Z",
    fill: "#697684"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5623 58.687C52.9526 58.687 53.269 59.0034 53.269 59.3938V65.3489C53.269 65.7392 52.9526 66.0557 52.5623 66.0557C52.1719 66.0557 51.8555 65.7392 51.8555 65.3489V59.3938C51.8555 59.0034 52.1719 58.687 52.5623 58.687Z",
    fill: "#697684"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3411 42.304C43.3411 41.9136 43.6575 41.5972 44.0478 41.5972H61.0765C61.4669 41.5972 61.7833 41.9136 61.7833 42.304V59.3959C61.7833 59.7862 61.4669 60.1027 61.0765 60.1027H44.0478C43.6575 60.1027 43.3411 59.7862 43.3411 59.3959V42.304ZM44.7546 43.0107V58.6891H60.3697V43.0107H44.7546Z",
    fill: "#697684"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3684 41.5972H67.432V43.0107H61.782V58.6891H67.432V60.1027H60.3684V41.5972Z",
    fill: "#697684"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5623 41.5972C52.9526 41.5972 53.269 41.9136 53.269 42.304V48.2591C53.269 48.6494 52.9526 48.9658 52.5623 48.9658C52.1719 48.9658 51.8555 48.6494 51.8555 48.2591V42.304C51.8555 41.9136 52.1719 41.5972 52.5623 41.5972Z",
    fill: "#697684"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0706 76.4871C20.0706 76.0967 20.387 75.7803 20.7773 75.7803H37.806C38.1964 75.7803 38.5128 76.0967 38.5128 76.4871V93.579C38.5128 93.9693 38.1964 94.2858 37.806 94.2858H20.7773C20.387 94.2858 20.0706 93.9693 20.0706 93.579V76.4871ZM21.4841 77.1938V92.8722H37.0992V77.1938H21.4841Z",
    fill: "#697684"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0981 76.4871C37.0981 76.0967 37.4146 75.7803 37.8049 75.7803H44.1618C44.5521 75.7803 44.8686 76.0967 44.8686 76.4871V93.579C44.8686 93.9693 44.5521 94.2858 44.1618 94.2858H37.8049C37.4146 94.2858 37.0981 93.9693 37.0981 93.579V76.4871ZM38.5117 77.1938V92.8722H43.455V77.1938H38.5117Z",
    fill: "#697684"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2917 75.7803C29.6821 75.7803 29.9985 76.0967 29.9985 76.4871V82.4422C29.9985 82.8325 29.6821 83.149 29.2917 83.149C28.9014 83.149 28.585 82.8325 28.585 82.4422V76.4871C28.585 76.0967 28.9014 75.7803 29.2917 75.7803Z",
    fill: "#697684"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0706 59.3938C20.0706 59.0034 20.387 58.687 20.7773 58.687H37.806C38.1964 58.687 38.5128 59.0034 38.5128 59.3938V76.4857C38.5128 76.8761 38.1964 77.1925 37.806 77.1925H20.7773C20.387 77.1925 20.0706 76.8761 20.0706 76.4857V59.3938ZM21.4841 60.1006V75.7789H37.0992V60.1006H21.4841Z",
    fill: "#697684"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0981 59.3938C37.0981 59.0034 37.4146 58.687 37.8049 58.687H44.1618C44.5521 58.687 44.8686 59.0034 44.8686 59.3938V76.4857C44.8686 76.8761 44.5521 77.1925 44.1618 77.1925H37.8049C37.4146 77.1925 37.0981 76.8761 37.0981 76.4857V59.3938ZM38.5117 60.1006V75.7789H43.455V60.1006H38.5117Z",
    fill: "#697684"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2917 58.687C29.6821 58.687 29.9985 59.0034 29.9985 59.3938V65.3489C29.9985 65.7392 29.6821 66.0557 29.2917 66.0557C28.9014 66.0557 28.585 65.7392 28.585 65.3489V59.3938C28.585 59.0034 28.9014 58.687 29.2917 58.687Z",
    fill: "#697684"
  })));
};
var Memo = /*#__PURE__*/memo(SvgCompany);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/illustrations/Company.9da3169fe8723b008b53c8db3aa5106f.svg";